import utils from '../utils';
import context from '../context';
import { DISPLAY_MODES } from '../constants';

export default function getTimeOffDates(event, displayMode, relevantDays) {
  const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;

  let start = utils.getRealDate(event.dtstart);
  let end = utils.getRealDate(event.dtend);

  let eventDtstart = utils.toDateObject(event.dtstart);
  let eventDtend = utils.toDateObject(event.dtend);
  let eventDtendString = utils.toDateString(event.dtend);
  const isEventExtended = typeof event.dtstart !== 'string';

  let isOverMidnight = false;
  if (event.fullDay) {
    if (!isEventExtended) {
      /**
       * Do the dtstart/end manipulation that would be done
       * whilst extending events
       */
      const { visibleStart: businessDtstart } = utils.getBusinessDayForCalendar(
        visibleHoursStart,
        visibleHoursEnd,
        eventDtstart
      );
      const { visibleEnd: businessDtend } = utils.getBusinessDayForCalendar(
        visibleHoursStart,
        visibleHoursEnd,
        eventDtend
      );

      eventDtstart = businessDtstart;
      eventDtend = businessDtend;
      eventDtendString = utils.toDateString(eventDtend);
    }

    start = utils.dateFromHours('00:00:00', eventDtstart);

    const businessDayStart = utils.dateFromHours(visibleHoursStart);
    const businessDayEnd = utils.dateFromHours(visibleHoursEnd);

    if (businessDayStart > businessDayEnd) {
      end = utils.dateFromHours('00:00:00', eventDtend);
    } else {
      isOverMidnight = true;
      end = utils.dateFromHours('23:59:59', eventDtend);
    }
  }

  const dates = utils.getDatesBetween(start, end, true);
  if (!dates.length) {
    return [utils.dateFromHours('00:00:00', eventDtstart)];
  }

  const businessDates = utils.getBusinessDaysBetween(
    visibleHoursStart,
    visibleHoursEnd,
    event,
    relevantDays
  );

  if (!businessDates.length) {
    return [];
  }

  const lastBusinessDay = utils.getBusinessDayForCalendar(
    visibleHoursStart,
    visibleHoursEnd,
    businessDates[businessDates.length - 1]
  );

  if (dates.length === 1) {
    return dates;
  }

  if (
    utils.formatDate(lastBusinessDay.visibleStart) === utils.formatDate(lastBusinessDay.visibleEnd)
  ) {
    if (
      utils.formatDate(dates[dates.length - 1]) !== utils.formatDate(lastBusinessDay.visibleEnd)
    ) {
      return dates.slice(0, -1);
    }
    return dates;
  }

  if (displayMode === DISPLAY_MODES.DAY) {
    return businessDates.map((businessDay) => utils.getRealDate(`${businessDay} 00:00:00`));
  }

  const isOnBussinessDayEnd =
    !event.fullDay &&
    eventDtendString === utils.formatDate(lastBusinessDay.visibleEnd) &&
    utils.formatTime(end) !== '0:00';
  const isFullDayCrossMidnight = event.fullDay && isOverMidnight;
  if (isOnBussinessDayEnd || isFullDayCrossMidnight) {
    return dates.slice(0, -1);
  }

  return dates;
}
